<template>
<ContentWrapper>
    <div class="content-heading">
      <div>{{`My Learning Path ${info.qrContSeq == 0 ? '등록' : '수정'}`}}</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          콘텐츠 관리
        </li>
        <li class="breadcrumb-item active">
          <a :href="page.prevUrl">{{page.prevTitle}}</a>
        </li>
      </ol>
    </div>

    <!-- 상세 -->
    <div class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
        <div class="footer mt-3">
          <div class="float-right">
              <b-button v-show="atrbInfo.qr_conts.length != 0" @click="saveAndRefresh()" class="btn btn-b btn-info mr-2" variant="info mr-2">{{info.qrContSeq == 0 ? '저장' : '수정'}}</b-button>
              <b-button v-show="info.qrContSeq != 0 && atrbInfo.qr_conts.length != 0" @click="remove()" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">삭제</b-button>
              <b-button @click="list()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 발송대상 검색 및 선택-->
    <div class="card card-default book-list">
      <div class="card-header mt-2">
        <span class="text-bold h4">My Learning Path</span>
        <div class="card-tool float-right">
          <b-btn v-show="info.qrContSeq == 0" class="btn btn-sm btn-outline-info mr-2" variant="outline-primary"
            @click="openPortfolioExcel();">파일 선택</b-btn>
            <input v-show="false" ref="fileInput" type="file" @change="readPortfolioExcel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        </div>

        <!-- 영여포트폴리오 교재 정보 -->
        <div class="form-group mt-3 p-2" style="border:1px solid #23b7e5">
          <table class="table table-bordered table-hover">
              <colgroup>
              <col width="12%"/>
              <col width="38%"/>
              <col width="12%"/>
              <col width="38%"/>
            </colgroup>
            <tbody>
              <tr>
                <td class="align-middle text-center">교재명</td>
                <td class="align-middle"> <b>{{(atrbInfo.qr_conts[0]||{}).title||''}}</b> </td>
                <td class="align-middle text-center">저자</td>
                <td class="align-middle"> {{(atrbInfo.qr_conts[0]||{}).author||''}} </td>
              </tr>
              <tr>
                <td class="align-middle text-center">교재ID</td>
                <td class="align-middle"> {{(atrbInfo.qr_conts[0]||{}).bookId||''}} </td>
                <td class="align-middle text-center">ISBN Code</td>
                <td class="align-middle"> {{(atrbInfo.qr_conts[0]||{}).isbnCd||''}} </td>
              </tr>
              <tr>
                <td class="align-middle text-center">수정일</td>
                <td class="align-middle"> {{atrbInfo.last_update_dt||''}} </td>
                <td class="align-middle text-center">등록일</td>
                <td class="align-middle"> {{(atrbInfo.qr_conts[0]||{}).regDt||''}} </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 1. 임시 대상 -->
        <span class="text-bold h5">총 {{atrbInfo.qr_questions.length}}문제</span>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="searchTemp" />
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="10%" style="text-align:center" >단원/차시/페이지</td>
              <td width="10%" style="text-align:center" >QR/영역(탭)/대분류</td>
              <td width="13%" style="text-align:center" >영역내질문/코너</td>
              <td width="13%" style="text-align:center" >입력방식/옵션</td>
              <td width="13%" style="text-align:center" >지시문</td>
              <td width="10%" style="text-align:center" >보기/고정텍스트</td>
              <td width="27%" style="text-align:center" >선지/가이드텍스트/참조행</td>
            </tr>
          </thead>
          <tbody>
                    <!-- v-validate="'required|min:10'" name="msgEmail" :class="{'is-invalid':errors.has('edit.msgEmail')}" -->
            <tr v-show="data.count==0" class="text-center"><td colspan="9">No records</td> </tr>
            <template v-for="(qr_q, index) in data.list">
              <tr v-if="true" :key="index">
                <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">
                  <!-- <div v-if="!checkData_csContSeq(qr_q)" style="color: red;">Do not matched !!</div>
                  <table v-else class="table table-bordered"> -->
                  <table class="table table-bordered">
                    <tr v-if="!checkData_csContSeq(qr_q)" style="border-style: dashed; color: red">{{ ((searchQrCont(qr_q)||{}).csContSeq+';').split(';')[0] }} </tr>
                    <tr v-else style="border-style: dashed;">{{ (searchQrCont(qr_q, '501001')||{}).title }} </tr>
                    <tr v-if="!checkData_csContSeq(qr_q)" style="border-style: dashed; color: red">{{ ((searchQrCont(qr_q)||{}).csContSeq+';').split(';')[1] }} </tr>
                    <tr v-else style="border-style: dashed;">{{ (getCsCont((searchQrCont(qr_q)||{}).csContSeq)||{}).title }} </tr>
                    <tr style="border-style: dashed;">{{ ((searchQrCont(qr_q)||{}).pageNum||0) }}p </tr>
                  </table>
                </td>
                <td class="align-middle text-center">
                  <table class="table table-bordered">
                    <tr style="border-style: dashed;">QR{{ (searchQrCont(qr_q)||{}).qrNum }}</tr>
                    <tr style="border-style: dashed;">{{ ((searchQrCont(qr_q, '501002')||{}).title||'-') }} </tr>
                    <tr style="border-style: dashed;">{{ ((searchQrCont(qr_q, '501003')||{}).title||'-') }} </tr>
                  </table>
                </td>
                <td class="align-middle text-center">
                  <table class="table table-bordered">
                    <tr style="border-style: dashed;">{{ ((searchQrCont(qr_q, '501004')||{}).title||'-') }} </tr>
                    <tr style="border-style: dashed;">{{ ((searchQrCont(qr_q, '501005')||{}).title||'-') }} </tr>
                  </table>
                </td>
                <td class="align-middle text-center">
                  <table class="table table-bordered">
                    <tr v-if="!checkData_qrQuestionType(qr_q)" style="border-style: dashed; color: red;">{{ qr_q.questionTypeCd||'-' }} </tr>
                    <tr v-else style="border-style: dashed;">{{ (getCsCodeNm(atrbInfo.qr_question_type_cds, qr_q.questionTypeCd)||'-') }} </tr>
                    <tr v-if="!checkData_qrQuestionOpt(qr_q)" style="border-style: dashed; color: red;">{{ qr_q.questionContent.question_option||'-' }} </tr>
                    <tr v-else style="border-style: dashed;">{{ (getCsCodeNm(atrbInfo.qr_question_opt_cds, qr_q.questionContent.question_option)||'-') }} </tr>
                  </table>
                </td>
                <td class="align-middle text-center">{{qr_q.questionContent.content.directive||'-'}}</td>
                <td class="align-middle text-center">
                  <div v-if="!(qr_q.questionContent.content.example && qr_q.questionContent.content.example.length) &&
                             !qr_q.questionContent.content.input_fixed_text">-</div>
                  <table v-if="qr_q.questionContent.content.example && qr_q.questionContent.content.example.length" class="table table-bordered">
                    <tr v-for="(ex) in qr_q.questionContent.content.example" :key="ex" style="border-style: dashed;">{{ ex }} </tr>
                  </table>
                  <div v-if="qr_q.questionContent.content.input_fixed_text" v-html="qr_q.questionContent.content.input_fixed_text"></div>
                </td>
                <td class="align-middle text-left">
                  <div v-if="!(qr_q.questionContent.content.choices && qr_q.questionContent.content.choices.length) &&
                             !qr_q.questionContent.content.input_guide_text &&
                             !qr_q.questionContent.content.divide_text">-</div>
                  <jodit-editor
                    v-if="qr_q.questionContent.content.choices && qr_q.questionContent.content.choices.length"
                    id="jodit_edit"
                    v-model="qr_q.questionContent.content.choices_join"
                    :config="_jodit_config.config"
                    :buttons="_jodit_config.buttons"
                    :plugins="_jodit_config.plugins"
                    :style="'min-height:200px;'"
                  />
                  <div v-if="qr_q.questionContent.content.input_guide_text" v-html="qr_q.questionContent.content.input_guide_text" style="text-align: left;"></div>
                  <div v-if="qr_q.questionContent.content.divide_text" v-html="qr_q.questionContent.content.divide_text" style="text-align: left;"></div>
                  <div v-if="qr_q.refQuestionIdx >= 0">참조행 번호: {{ qr_q.refQuestionIdx+1 }}</div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="form-group no-margin row mt-2" style="width:100%">
        </div>  
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(searchTemp)" @prev="dataAction.prev(searchTemp)" @first="dataAction.first(searchTemp)" @last="dataAction.last(searchTemp)" :key="data.params.page"/>
        </div>

      </div>
    </div>

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<style scoped>
  .is-invalid {
    border: 1px solid red;
  }
</style>
<script>
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted, nextTick } from '@vue/composition-api'
import {saveQrCont, saveQrContQuestion, getQrContDetail, deleteQrCont, deleteQrContQuestion} from "@/api/cs/QrContApi";
import {dataObject, ValueTexts, messageSendTypes, userTypeCd, YnOption, schoolGrdCdOption, subjectCd1, subjectCd2, subjectCd3} from "@/utils/Constants";
import {getLmTextBookItemInfo} from "@/api/lm/LmTextBookApi";
import {getCsContTreeList} from "@/api/cs/CsContApi";
import {getCsCodeList} from "@/api/cs/CsCodeApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import ShowCounter from "../../components/Common/ShowCounter";
import {downloadUrl} from "@/utils/common-util";
import Xlsx from 'xlsx';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

/*
// quill Editor
import { quillEditor } from "vue-quill-editor";   
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
*/

// jodit Editor
import 'jodit/build/jodit.min.css'
import { JoditEditor } from 'jodit-vue'
import { jodit_config } from '@/components/Common/jodit_config'


export default {
    components: {ShowCounter, Pagenation, Loading, JoditEditor},
    props: {
      seq:{
        type:Number|String,
        default:0, // 0: 등록, 그외: 수정
      },
    },
    setup(props, {root}) {
      const modalLoading = ref(false);
      const atrbInfo = reactive({
        lmTextBook:{}, // LmTextBook
        result:[], // CsContTreeList
        depth1:[], // 단원, 목차
        depth2:[], // 차시, 코너
        qr_question_type_cds:[],
        qr_question_opt_cds:[],

        qr_conts:[],
        qr_questions:[],
        last_update_dt: '',
      });

      // 임시회원 목록을 위한 데이터
      const _dataObject = _.cloneDeep(dataObject);
      const data = reactive(_dataObject);
      data.params.limit = 100;

      const page = reactive({
        prevUrl:'',
        prevTitle:'',
      });
      const info = reactive({
        qrContSeq:props.seq,
      });
      
      page.prevUrl = '/cs/portfolio';
      page.prevTitle = 'My Learning Path 관리';

      let _jodit_config = $.extend(true, {}, jodit_config);
      _jodit_config.buttons = 
        ['bold',{
            name: 'small',
            icon: '',
            tooltip: '작게',
            exec: (editor) => {
                var text = editor.s.html;
                if (!text) return;

                // calc editor selection offset length
                var sel = editor.s.sel;
                var selOffset = sel.anchorOffset;
                var selLength = sel.focusOffset-sel.anchorOffset;
                var node;
                for (node = sel.anchorNode; node && node !== sel.focusNode; node = node.nextSibling) {
                    selLength += node.textContent.length;
                }
                for (node = sel.anchorNode; node && node !== editor.editor; node = node.parentNode) {
                    while (node.previousSibling) {
                        node = node.previousSibling;
                        selOffset += node.textContent ? node.textContent.length : 0;
                    }
                }
                // console.log('selOffset, selLength', selOffset, selLength);

                // main
                var hasCustomTag = false;
                var html = '';
                if (text.includes('<small>')) { // selection의 일부만 small일 때.
                    html = text.replace('<small>','').replace('</small>','');
                } else if (editor.s.sel.baseNode.parentNode.tagName == 'SMALL') { // selection의 전부 small tag 내부일 때.
                    html = '{/small}' + text + '{small/}'; // temporary custom tag
                    hasCustomTag = true;
                } else {
                    html = '<small>' + text + '</small>'
                }
                editor.s.remove();
                editor.s.insertHTML(html, true);

                var v = editor.value||'';
                if (hasCustomTag) {
                    v = v.replace(/{\/small}/g, '<\/small>').replace(/{small\/}/g, '<small>');
                }
                v = v.replace(/<small><\/small>/g, '').replace(/<\/small><small>/g, '');
                editor.value = v;

                // generate editor new selection: offset length
                var anchorOffset = selLength < 0 ? selOffset+selLength : selOffset;
                var anchorLength = Math.abs(selLength);
                node = editor.editor;
                for (var i = 0; node && node.childNodes && i < node.childNodes.length; i++) {
                    if (anchorOffset < node.childNodes[i].textContent.length) {
                        node = node.childNodes[i];
                        i = -1;
                        if (!node.childNodes || node.childNodes.length == 0) {
                            anchorLength = Math.min(anchorLength, node.textContent.length-anchorOffset);
                            break;
                        }
                    } else {
                        anchorOffset -= node.childNodes[i].textContent.length;
                    }
                }
                // console.log('anchorOffset, anchorLength', anchorOffset, anchorLength);
                var range = document.createRange()
                range.setStart(node, anchorOffset);
                range.setEnd(node, anchorOffset+anchorLength);
                range.collapse(selLength < 0); // false -> at end
                editor.s.selectRange(range);
            }}, 'italic', '|', 'source'];

      const retVals = {
        modalLoading,
        atrbInfo,
        data,
        page,
        info,
        _jodit_config,
        ...methods(props, atrbInfo, data, info),
        dataAction: new TableActionClass(data),
      }

      onMounted(async () => {
        await retVals.detail();
      });
      // 입력에 특정 문자를 못지우게하기.
      // watch(() => info.msg, (newValue, oldValue) => {
      //   console.log('info.msg(info.msg,new,old): ', info.msg, newValue, oldValue)

      //   if (!newValue.includes('test')) {
      //     nextTick(() => {
      //       info.msg = oldValue;
      //     });
      //   }
      // });

      return retVals;
    }
}

function methods(props, atrbInfo, data, info) {
  function choices_join(choices) {
    return '<p>'+choices.map(c => c.replace(/<br>/gi,'&lt;br&gt;')).join('<br>')+'</p>';
  }
  function choices_split(choices_join) {
    return choices_join.replace(/<p>/gi,'').replace(/<\/p>/gi,'').split('<br>').map(c => c.replace(/&lt;br&gt;/g,'<br>'));
  }

  // 상세
  async function detail() {
    if (info.qrContSeq != 0) {
      this.modalLoading = true;

      const params = { qrContSeq: info.qrContSeq };
      let result = await getQrContDetail(params);
      if (!result.data) {
        this.modalLoading = false;
        alert('상세정보 불러오기에 실패했습니다!')
        return;
      }
      let qr_conts = result.data.qr_conts||[];
      let qr_questions = result.data.qr_questions||[];

      qr_conts.forEach(c => {
        c.prContIdx = qr_conts.findIndex(e => e.qrContSeq == c.prContSeq);
      });
      qr_questions.forEach(q => {
        q.questionContent = JSON.parse(q.questionContent);
        q.qrContIdx= qr_conts.findIndex(e => e.qrContSeq == q.qrContSeq);;
        q.refQuestionIdx = (q.refQuestionSeq > 0 ? qr_questions.findIndex(e => e.questionSeq == q.refQuestionSeq) : -1);
        if (q.questionContent.content.choices) {
          // q.questionContent.content.choices_join = '<p>'+q.questionContent.content.choices.join('<br>')+'</p>';
          q.questionContent.content.choices_join = choices_join(q.questionContent.content.choices);
        }
      });
      let last_update_dt = '';
      last_update_dt = qr_conts.reduce((acc,cur) => acc >= cur.updDt ? acc : cur.updDt, last_update_dt);
      last_update_dt = qr_questions.reduce((acc,cur) => acc >= cur.updDt ? acc : cur.updDt, last_update_dt);

      console.log('detail load', qr_conts, qr_questions);
      atrbInfo.qr_conts = qr_conts;
      atrbInfo.qr_questions = qr_questions;
      atrbInfo.last_update_dt = last_update_dt;

      if (atrbInfo.result.length == 0) {
          let _atrbInfo = await this.loadCsCont(null, qr_conts[0].bookId);
          if (!_atrbInfo) {
            this.modalLoading = false;
            return;
          }
      }

      this.searchTemp();
      this.modalLoading = false;
    }
  }

  async function remove() {
    if (!confirm('정말 삭제하시겠습니까?')) {
      return;
    }

    let params = atrbInfo.qr_conts.map(e => { return {qrContSeq: e.qrContSeq}});
    let result = await deleteQrCont(params);
    console.log(`deleteQrCont(): ${result.data}/${params.length}`);

    params = atrbInfo.qr_questions.map(e => { return {questionSeq: e.questionSeq}});
    result = await deleteQrContQuestion(params);
    console.log(`deleteQrContQuestion(): ${result.data}/${params.length}`);

    alert('삭제했습니다.');
    this.$router.go(-1);
  }

  function list() {
    this.$router.go(-1);
  }

  // 엑셀파일로 임시 목록에 추가
  function openPortfolioExcel() {
    console.log('openPortfolioExcel, ', event);
    const fileInput = this.$refs.fileInput;
    fileInput.click();
  }

  // params 3중 1개만 사용.
  async function loadCsCont(isbn_cd, book_id, cont_seq) {
    let _atrbInfo = atrbInfo;

    // lm_text_book (교재 정보)
    let param = {
      isbnCd: isbn_cd || null,
      bookId: book_id || null,
      contSeq: cont_seq || null,
    }
    let result =  await getLmTextBookItemInfo(param);
    if(!result.data){
      alert('교재정보 가져오기에 실패했습니다');
      return null;
    }
    _atrbInfo.lmTextBook = result.data;
    _atrbInfo.result = [];
    _atrbInfo.depth1 = [];
    _atrbInfo.depth2 = [];

    // make cs_cont tree (단원/차시 정보) [단원 : 202004, 목차 : 202005], 차시 : 202006, 코너 : 202007
    param = {
      pContSeq: _atrbInfo.lmTextBook.contSeq, // orgContSeq,
      contTypeCd: '201002',  // 교재
      //postTypeCd: postTypeCd,
      sort: 'order_num',
      limit: 10000
    }
    result = await getCsContTreeList(param)
    if(!result.data){
      _atrbInfo.lmTextBook = {};
      alert('차시정보 가져오기에 실패했습니다');
      return null;
    }
    _atrbInfo.result = result.data;
    _atrbInfo.depth1 = [];
    _atrbInfo.depth2 = [];
    result.data.forEach(function(e) {
      if (e.leafYn != 'Y') {
        _atrbInfo.result.forEach(function(f) {
          if (f.pcontSeq == e.contSeq ) {
            f.parent = e;
          }
        });
      }
      if (e.postTypeCd == '202004' || e.postTypeCd == '202005') {
        _atrbInfo.depth1.push(e)
      } else if (e.postTypeCd=='202006' || e.postTypeCd == '202007') {
        _atrbInfo.depth2.push(e)
      }
    });
    // _atrbInfo.result.forEach(function(f) { // check
    //   if (!f.parent && f.postTypeCd != '202004') console.log(f);
    // });
    _atrbInfo.depth1.sort(function(a,b){ return a.orderNum - b.orderNum; })
    _atrbInfo.depth2.sort(function(a,b){ return a.orderNum - b.orderNum; });

    // download codes
    result = await getCsCodeList({pCode: 'PF_QUESTION_TYPE_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
    _atrbInfo.qr_question_type_cds = result.data || [];
    result = await getCsCodeList({pCode: 'PF_QUESTION_OPT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
    _atrbInfo.qr_question_opt_cds = result.data || [];

    return _atrbInfo;
  }

  function csContCompStr(str) {
    return (''+(str||'')).trim();
  }
  function searchCsCont(_atrbInfo, big_title, small_title) {
    big_title = csContCompStr(big_title);
    small_title = csContCompStr(small_title);
    if (!small_title) {
      for (let cs_cont1 of _atrbInfo.depth1) {
        if (csContCompStr(cs_cont1.title) == big_title) {
          return cs_cont1; // found!
        }
      }
    } else {
      for (let cs_cont2 of _atrbInfo.depth2) {
        if (csContCompStr(cs_cont2.title) == small_title) {
          for ( let cs_cont1 = cs_cont2.parent; cs_cont1 ; cs_cont1 = cs_cont1.parent) {
            if (csContCompStr(cs_cont1.title) == big_title) {
              return cs_cont2; // found!
            }
          }
        }
      }
    }
    return null; // not found.
  }

  // 파일로드일때는 prContSeq재할당 필요.
  // 수정일 경우는 prContIdx 재할당 필요.
  function addQrCont(qr_cont_list, pr_cont_seq, page_num, cs_cont_seq, qr_num, qr_post_type_cd, title, order_num) {
    const qr_cont = {
      qrContSeq: -1,
      prContIdx: pr_cont_seq,
      prContSeq: pr_cont_seq,
      orgContSeq: 0,
      pageNum: page_num,
      csContSeq: cs_cont_seq,
      qrNum: qr_num,
      qrPostTypeCd: qr_post_type_cd,
      title: title,
      orderNum: order_num,
    };
    qr_cont_list.push(qr_cont);
    return qr_cont_list.length-1; // last idx
  }

  async function readPortfolioExcel(event) {
    console.log('readPortfolioExcel, ', event);

    // get File object from input tag
    const file = event.target.files[0]; 
    if (!file) {
      return;
    }
    const fileName = file.name; 
    const reader = new FileReader(); 

    this.modalLoading = true;
    // if you use "this", don't use "function(e) {...}" 
    reader.onload = async (e) => { 
      let data = e.target.result; 
      data = new Uint8Array(data); 
      // get excel file 
      const excelFile = Xlsx.read(data, { type: "array" });

      if (excelFile.SheetNames.length > 0) {
        const firstSheetName = excelFile.SheetNames[0];
        const firstSheet = excelFile.Sheets[firstSheetName];
        const roa = Xlsx.utils.sheet_to_json(firstSheet, /*{header:1}*/);
        if (roa.length) {
          const beautifyText = (text) => {
            text = (text+'');
            text = text.trim() == '-' || text.trim() == '' || text.trim() == 'undefined' ? '': text;
            return text.replace(/[\r]/g, '').replace(/[\n]/g, '<br>');
          }
          const addList = roa.map((item) => {
            let map_data = {
              'question_number'  :beautifyText(item['번호']).trim().replace(/<br>/g,'').trim(),
              'big_chapter'      :beautifyText(item['단원']).trim().replace(/<br>/g,'').trim(),
              'page'             :beautifyText(item['교과서 페이지']),
              'small_chapter'    :beautifyText(item['차시정보']).trim().replace(/<br>/g,'').trim(),
              'qr_num'           :beautifyText(item['QR 순서']).trim().replace(/QR/,'')*1,
              'tab_big'          :beautifyText(item['영역(탭)']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
              'tab_small'        :beautifyText(item['탭 내 대분류']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
              'block_title'      :beautifyText(item['영역 내 질문']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
              'corner'           :beautifyText(item['코너']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
              'question_type'    :beautifyText(item['입력 방식']).trim(),
              'directive'        :beautifyText(item['지시문']),
              'question_option'  :beautifyText(item['옵션']).trim(),
              'example'          :beautifyText(item['보기']),
              'choices'          :[beautifyText(item['선지1']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지2']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지3']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지4']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지5']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지6']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지7']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지8']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지9']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지10']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지11']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim(),
                                   beautifyText(item['선지12']).trim().replace(/^<br>/,'').replace(/<br>$/,'').trim()],
              'ref_row'          :beautifyText(item['참조행']),
              'input_fixed_text' :beautifyText(item['고정 텍스트']),
              'input_guide_text' :beautifyText(item["입력창 내 가이드텍스트\r\n(*작성자가 영역 클릭하면 텍스트 사라짐)"]),
              'choice_bold_text' :beautifyText(item['볼드처리 필요한 경우']),
              'choice_small_text':beautifyText(item['폰트크기 축소 필요한 경우']),
              'divide_text'      :beautifyText(item["단락 구분 시 들어가야 하는 텍스트\r\n*예시 문장까지 작성"]),
              'note'             :beautifyText(item['비고']),
              'url'              :beautifyText(item['최종 URL']),
            }
            map_data['input_guide_text'] = map_data['input_guide_text'] || beautifyText(item["입력창 내 가이드텍스트\n(*작성자가 영역 클릭하면 텍스트 사라짐)"]);
            map_data['divide_text'] = map_data['divide_text'] || beautifyText(item["단락 구분 시 들어가야 하는 텍스트\n*예시 문장까지 작성"]);
            return map_data;
          });
          console.log('addList:', addList);

          // const isbn_cd = fileName.split('_')[0];
          const fileNameAttrs = fileName.split('_');
          const id = fileNameAttrs[0];
          const format_version = fileNameAttrs.length > 1 ? fileNameAttrs[1] : '';
          let _atrbInfo = (id||'').startsWith('ISBN') ? await this.loadCsCont(id, null) : await this.loadCsCont(null, id);
          if (!_atrbInfo) {
            this.modalLoading = false;
            return;
          }

          _atrbInfo.qr_conts = [];
          _atrbInfo.qr_questions = [];

          let qr_conts = [];
          let qr_questions = [];

          let big_title = ''; // 단원
          let small_title = ''; // 차시
          let page_num = 0;
          let cs_cont_seq = 0;
          let last_qr_cont_idx = 0;
          let pr_cont_idx = {
            '501000': -1,
            '501001': -1,
            '501002': -1,
            '501003': -1,
            '501004': -1,
          };
          let qr_num = 0;
          let qr_post_type_cd = ''; // '501000' - 교재제목 , '501001' - 단원 , '501002' - 영역(탭) , '501003' - 탭내대분류,  '501004' - 영역내질문  , '501005' - 코너
          let title = 0;
          let order_num = {
            '501001': 1,
            '501002': 1,
            '501003': 1,
            '501004': 1,
            '501005': 1,
            'question': 1,
          };

          // addQrCont(qr_cont_list, pr_cont_seq, page_num, cs_cont_seq, qr_num, qr_post_type_cd, title, order_num)
          // - pr_cont_seq는 list index로 넣고, insert api에서 seq로 변경한다.

          pr_cont_idx['501000'] = addQrCont(qr_conts, -1, 0, _atrbInfo.lmTextBook.contSeq, 0, '501000', _atrbInfo.lmTextBook.title, 0); // top: 교재 제목
          qr_conts[0].author = _atrbInfo.lmTextBook.author;
          qr_conts[0].bookId = _atrbInfo.lmTextBook.bookId;
          qr_conts[0].isbnCd = _atrbInfo.lmTextBook.isbnCd;
          qr_conts[0].pubDt = _atrbInfo.lmTextBook.pubDt;

          addList.forEach((row, idx) => {
            // qr_cont
            if (row.big_chapter) { // 단원
              big_title = row.big_chapter;
              cs_cont_seq = (searchCsCont(_atrbInfo, big_title, '')||{}).contSeq||big_title||'';
              pr_cont_idx['501001'] = addQrCont(qr_conts, pr_cont_idx['501000'], 0, cs_cont_seq, 0, '501001', big_title, order_num['501001']++);
              pr_cont_idx['501002'] = pr_cont_idx['501001'];
              pr_cont_idx['501003'] = pr_cont_idx['501001'];
              pr_cont_idx['501004'] = pr_cont_idx['501001'];
              order_num['501002'] = 1;
              order_num['501003'] = 1;
              order_num['501004'] = 1;
              order_num['501005'] = 1;
              order_num['question'] = 1;
            }
            if (row.page) page_num = parseInt((row.page||'').replace(/^[A-Za-z .\-]*/,''))||0;
            if (row.small_chapter) {
              small_title = row.small_chapter;
              // small_title = small_title.replace(/-[0-9]+/, ''); // ex) 8-9차시 => 8차시
              if (/^[0-9]+$/.test(small_title)) small_title = small_title+'차시';
              cs_cont_seq = (searchCsCont(_atrbInfo, big_title, small_title)||{}).contSeq||big_title+';'+small_title;
            }
            if (row.qr_num) qr_num = row.qr_num;
            if (row.tab_big) { // 영역(탭)
              last_qr_cont_idx = pr_cont_idx['501002'] = addQrCont(qr_conts, pr_cont_idx['501001'], page_num, cs_cont_seq, qr_num, '501002', row.tab_big, order_num['501002']++); 
              pr_cont_idx['501003'] = pr_cont_idx['501002'];
              pr_cont_idx['501004'] = pr_cont_idx['501002'];
              order_num['501003'] = 1;
              order_num['501004'] = 1;
              order_num['501005'] = 1;
              order_num['question'] = 1;
            }
            if (row.tab_small) { // '탭 내 대분류'
              last_qr_cont_idx = pr_cont_idx['501003'] = addQrCont(qr_conts, pr_cont_idx['501002'], page_num, cs_cont_seq, qr_num, '501003', row.tab_small, order_num['501003']++); 
              pr_cont_idx['501004'] = pr_cont_idx['501003'];
              order_num['501004'] = 1;
              order_num['501005'] = 1;
              order_num['question'] = 1;
            }
            if (row.block_title) { // '영역 내 질문'
              last_qr_cont_idx = pr_cont_idx['501004'] = addQrCont(qr_conts, pr_cont_idx['501003'], page_num, cs_cont_seq, qr_num, '501004', row.block_title, order_num['501004']++); 
              order_num['501005'] = 1;
              order_num['question'] = 1;
            }
            if (row.corner) { // '코너'
              last_qr_cont_idx = addQrCont(qr_conts, pr_cont_idx['501004'], page_num, cs_cont_seq, qr_num, '501005', row.corner, order_num['501005']++); 
              order_num['question'] = 1;
            }

            // qr_question
            let question_type_cd = (_atrbInfo.qr_question_type_cds.find(cd => cd.codeNm == row.question_type)||{}).code||'';
            let question_opt_cd = (_atrbInfo.qr_question_opt_cds.find(cd => cd.codeNm == row.question_option)||{}).code||'';
            if ((!question_type_cd && row.question_type) || (!question_opt_cd && row.question_option)) {
              console.log(`type/option ismatch!! [${row.question_type}] - [${row.question_option}]`);
            }
            let qr_question_content = {
              question_type: question_type_cd||row.question_type||'',
              question_option: question_opt_cd||row.question_option||'',
              content: {
              }
            }
            if (row.directive) qr_question_content.content.directive = row.directive;
            if (row.example) qr_question_content.content.example = row.example.split('<br>');
            let choices = row.choices.filter(c => c);
            if (choices.length > 0) {
              qr_question_content.content.choices = choices;
              // qr_question_content.content.choices_join = '<p>'+choices.join('<br>')+'</p>';
              qr_question_content.content.choices_join = choices_join(choices);
            }
            if (row.input_fixed_text) qr_question_content.content.input_fixed_text = row.input_fixed_text;
            if (row.input_guide_text) qr_question_content.content.input_guide_text = row.input_guide_text;
            if (row.divide_text) qr_question_content.content.divide_text = row.divide_text;
            let question_number = parseInt(row.question_number||'0')||0;
            let refQuestionIdx = -1;
            let refQuestionSeq = 0;
            if (row.ref_row) {
              if (question_opt_cd == '501213') { // '작성 내역이 다른 영역에 노출'은 문제행번호를 만든다.
                let ref_seq = row.ref_row.replace(/ /g,'').match(/[0-9]+번/);
                if (ref_seq && ref_seq.length > 0) {
                  let num = parseInt(ref_seq[0])||0;
                  // const ref_question_idx = num - 3; // 1 + 1(title) + 1(header);
                  const ref_question_idx = qr_questions.findIndex(q => q.question_number == num);
                  if (ref_question_idx >= 0) {
                    refQuestionIdx = ref_question_idx;
                  }
                }
              }
            } else if (format_version == 'v1.0' && row.note) {
              if (question_opt_cd == '501213') { // '작성 내역이 다른 영역에 노출'은 문제행번호를 만든다.
                let ref_seq = row.note.replace(/ /g,'').match(/[0-9]+행/);
                if (ref_seq && ref_seq.length > 0) {
                  let num = parseInt(ref_seq[0])||0;
                  const ref_question_idx = num - 3; // 1 + 1(title) + 1(header);
                  if (ref_question_idx >= 0) {
                    refQuestionIdx = ref_question_idx;
                  }
                }
              }
            }
            // 'choice_bold_text' / 'choice_small_text' / 'note' / 'url'  참고용으로 보여줘야 하나????
            let qr_question = {
              questionSeq: -1,
              qrContIdx: last_qr_cont_idx,
              question_number,
              refQuestionSeq,
              refQuestionIdx,
              qrContSeq: last_qr_cont_idx, // 임시로 idx로 넣고 save api에서 할당.
              questionTypeCd: qr_question_content.question_type,
              questionContent: qr_question_content,
              orderNum: order_num['question']++,
              // page_num: page_num // 의미 없음 필드 없애자.
            };
            qr_questions.push(qr_question);
          });

          _atrbInfo.qr_conts = qr_conts;
          _atrbInfo.qr_questions = qr_questions;

          this.searchTemp();
          this.modalLoading = false;

          console.log('qr_conts', qr_conts);
        }
      }
    }; 
    reader.readAsArrayBuffer(file);
    event.target.value = '';
  }  

  function checkData_csContSeq(qr_question) {
    return !!getCsCont((searchQrCont(qr_question)||{}).csContSeq);
  }
  function checkData_qrQuestionType(qr_question) {
    return !!getCsCodeNm(atrbInfo.qr_question_type_cds, qr_question.questionTypeCd);
  }
  function checkData_qrQuestionOpt(qr_question) { // option은 없어도 정상 처리.
    return !qr_question.questionContent.question_option || !!getCsCodeNm(atrbInfo.qr_question_opt_cds, qr_question.questionContent.question_option);
  }

  // 기본정보 저장 & 화면 refresh
  async function saveAndRefresh() {
    const _atrbInfo = atrbInfo;
    let qr_conts = $.extend(true, [], _atrbInfo.qr_conts);
    let qr_questions = $.extend(true, [], _atrbInfo.qr_questions);

    // 저장 전 데이타 확인.
    if (qr_conts.length == 0 || qr_questions.length == 0) {
      alert('저장할 데이타가 없습니다.');
      return ;
    }
    for (let i = 0; i < qr_questions.length; i++) {
      const qr_q = qr_questions[i];
      if (!checkData_csContSeq(qr_q)) {
        alert(`교재와 연결되지 않은 문제가 있습니다!!\n${i+1}번 문제를 확인해주세요.`);
        return ;
      }
      if (!checkData_qrQuestionType(qr_q)) {
        alert(`알 수 없는 [입력방식]이 있습니다!!\n${i+1}번 문제를 확인해주세요.`);
        return ;
      }
      if (!checkData_qrQuestionOpt(qr_q)) {
        alert(`알 수 없는 [옵션]이 있습니다!!\n${i+1}번 문제를 확인해주세요.`);
        return ;
      }
    }

    // 저장
    if (!confirm(`${info.qrContSeq == 0 ? '저장' : '수정'}하시겠습니까?`)) {
      return;
    }
    qr_conts.forEach(c => {
      c.prContIdx = undefined;
      if (info.qrContSeq == 0) c.qrContSeq = -1;
    });
    qr_questions.forEach(q => {
      if (info.qrContSeq == 0) q.questionSeq = -1;

      if (q.questionContent.content.choices_join) {
        // q.questionContent.content.choices = q.questionContent.content.choices_join.replace(/<p>/gi,'').replace(/<\/p>/gi,'').split('<br>');
        q.questionContent.content.choices = choices_split(q.questionContent.content.choices_join);
      }
      q.questionContent.content.choices_join = undefined;

      q.questionContent = JSON.stringify(q.questionContent);
    });

    this.modalLoading = true;

    let params = qr_conts;
    console.log('saveQrCont, params:', params);
    let result = await saveQrCont(params);
    if(!result.data){
      if (result.message) {
        alert(result.message);
      } else {
        alert('QrCont 저장하기에 실패했습니다');
      }
    } else {
      qr_conts = result.data;

      qr_questions.forEach(q => {
        q.qrContSeq = qr_conts[q.qrContIdx].qrContSeq;
        q.qrContIdx= undefined;
      })
      params = qr_questions;
      console.log('saveQrContQuestion, params:', params);
      result = await saveQrContQuestion(params);
      if(!result.data){
        alert('QrQuestion 저장하기에 실패했습니다');
      } else {
        qr_questions = result.data;

        // set global
        _atrbInfo.qr_conts = qr_conts;
        _atrbInfo.qr_questions = qr_questions;
        info.qrContSeq = _atrbInfo.qr_conts[0].qrContSeq;
      }
    }

    // set ui
    this.detail();

    this.modalLoading = false;
  }

  function searchTemp(page) {
    this.searchForTotal(data, page);
  }

  function searchForTotal(data, page) {
    if (!isNaN(page)) {
      data.params.page = page;
    }

    let tmpDataList = [];
    const pageNo = data.params.page;
    let pageSize = data.params.limit;
    if (!isNaN(pageSize)) {
      pageSize = parseInt(pageSize);
    }
    const startIndex = pageSize * (pageNo-1);
    const endIndex = startIndex + pageSize - 1;
    
    console.log('startIndex, endIndex, qr_questions:', startIndex, endIndex, atrbInfo.qr_questions);
    for (let i = startIndex; i <= endIndex; i++) {
      const member = atrbInfo.qr_questions.at(i);
      if (member) {
        tmpDataList.push(member);
      }
    }
    data.list = tmpDataList;
    data.count = atrbInfo.qr_questions.length;
  }

  // qr_post_type가 ''면 연결된 말단 qr_cont를 반환.
  function searchQrCont(qr_q, qr_post_type) {
    if (qr_q.qrContIdx <= 0 || qr_q.qrContIdx >= atrbInfo.qr_conts.length) return null;

    const _qr_conts = atrbInfo.qr_conts;
    for (let qr_cont = _qr_conts[qr_q.qrContIdx]; qr_cont && qr_cont.prContIdx >= 0; qr_cont = _qr_conts[qr_cont.prContIdx]) {
      if (!qr_post_type || qr_cont.qrPostTypeCd == qr_post_type) return qr_cont;
    }
    return null;
  }

  function getCsCont(csContSeq) {
    if ((csContSeq||0) <= 0) return null;

    for (let cs_cont of atrbInfo.result) {
      if (cs_cont.contSeq == csContSeq) return cs_cont;
    }
    return null;
  }

  function getCsCodeNm(codes, code) {
    return (codes.find(c => c.code == code)||{}).codeNm;
  }

  return {
    detail,
    checkData_csContSeq,
    checkData_qrQuestionType,
    checkData_qrQuestionOpt,
    saveAndRefresh,
    remove,
    list,
    openPortfolioExcel,
    loadCsCont,
    readPortfolioExcel,
    searchTemp,
    searchForTotal,
    searchQrCont,
    getCsCont,
    getCsCodeNm,
  }
}

</script>